import { FaPlus, FaCheck } from "react-icons/fa";

function CreateNewPlaylistButton({
    key,
    setIsCreatingNewPlaylist,
    isCreatingNewPlaylist,
    setSelectedPlaylist,
}) {
    const createNewList = () => {
        setIsCreatingNewPlaylist(true);
        setSelectedPlaylist([]);
    };

    return (
        <div
            style={{
                width: "90%",
                margin: "0 1vh 0 1vh",
                borderRadius: "0.5vh",
                border: "none",
                padding: "1vh",
                backgroundColor: !isCreatingNewPlaylist ? "#3a5f8f" : "#4db193",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
            }}
            onClick={() => createNewList()}
        >
            <div style={{ width: "80%", textAlign: "left" }}>
                <div
                    style={{
                        color: "white",
                        fontSize: 14,
                    }}
                >
                    Lag ny spilleliste
                </div>
                <div
                    style={{
                        color: "white",
                        fontSize: 11,
                        opacity: 0.9,
                    }}
                >
                    Velg sanger selv!
                </div>
            </div>
            <div
                style={{
                    width: "10%",
                    display: "flex",
                    justifyContent: "flex-start",
                }}
            >
                {isCreatingNewPlaylist ? (
                    <FaCheck color="white" />
                ) : (
                    <FaPlus color="white" />
                )}
            </div>
        </div>
    );
}

export default CreateNewPlaylistButton;
